import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Drawer, useTheme, useMediaQuery } from '@mui/material';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

const Layout: React.FC = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [desktopExpanded, setDesktopExpanded] = useState(true);

  const handleMobileToggle = () => {
    setMobileOpen(prev => !prev);
  };

  const handleDesktopToggle = () => {
    setDesktopExpanded(prev => !prev);
  };

  const sidebarWidth = desktopExpanded ? '260px' : '72px';

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      {/* Mobile Drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        ModalProps={{ keepMounted: true }} // Better mobile performance
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: 280,
            bgcolor: '#0b2b4a',
            border: 'none',
          },
        }}
      >
        <Sidebar
          isMobile
          onItemClick={() => setMobileOpen(false)}
        />
      </Drawer>

      {/* Desktop Persistent Sidebar */}
      <Box
        sx={{
          display: { xs: 'none', md: 'block' },
          flexShrink: 0,
          width: sidebarWidth,
          transition: 'width 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        <Sidebar
          width={sidebarWidth}
          onMouseEnter={() => {}}
          onMouseLeave={() => {}}
        />
      </Box>

      {/* Main Content Column */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          minWidth: 0, // Critical to allow flex items to shrink and prevent horizontal overflow
          minHeight: '100vh',
        }}
      >
        {/* Sticky Header */}
        <Navbar
          onToggleMobileMenu={handleMobileToggle}
          onToggleDesktopSidebar={handleDesktopToggle}
          sidebarExpanded={desktopExpanded}
        />

        {/* Page Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: { xs: 2, sm: 3, md: 3.5 },
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;